<template>

  <el-dialog
    title="Редактировать ограничение"
    :visible="visible"
    :before-close="close"
    @opened="onOpen"
    @open="loading = !!1"
  >

    <el-form ref="editForm" :rules="editFormRules" :model="editForm" v-loading="loading">
      <el-form-item label="Название" prop="title" :error="errors.name | errorToSrt">
        <el-input name="title" ref="autoFocus" placeholder="Введите название" v-model="editForm.title"></el-input>
      </el-form-item>
    </el-form>

    <slot slot="footer" class="dialog-footer">
      <el-button type="primary" name="save" :loading="loading" @click="saveForm()">Сохранить</el-button>
    </slot>

  </el-dialog>
</template>

<script>
import Vue from 'vue'
import VueMask from 'v-mask'

Vue.use(VueMask)

export default {
  name: 'DialogWorkerEdit',
  data () {
    return {
      form: null,
      error: null,
      loading: false,
      loadBtn: false,
      errors: {},
      editForm: {},
      editFormRules: {
        title: [
          { required: true, message: 'Укажите название', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
  },
  props: {
    type: {
      default: true
    },
    visible: {
      required: true
    }
  },
  filters: {
    errorToSrt (t) {
      return t ? t.join(', ') : null
    }
  },
  methods: {
    onOpen () {
      this.loadLogic()
      this.loading = !!0
    },
    close () {
      this.$emit('close')
    },
    loadLogic () {
      this.autoFocus()
    },
    autoFocus () {
      this.$refs.autoFocus.focus()
    },
    saveForm (close) {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loadBtn = !!1

          const payLoad = {
            type: this.editForm.type,
            schema: {
              text: this.editForm.name,
              compendium: this.editForm.compendium
            }
          }
          this.$api.worker
            .edit(this.worker.id, payLoad)
            .then((response) => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Данные сохранены'
              })
              if (close) {
                this.$emit('update')
                this.$emit('close')
              } else {
                this.$emit('update')
                this.editForm = {
                  type: '20'
                }
                this.autoFocus()
              }
            })
            .catch((response) => {
              this.$notify.error({
                title: 'Ошибка',
                message: response.response.data.message
              })
            })
            .finally(() => {
              this.loadBtn = !!0
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.modal {
  &__mask {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  &__wrapper {
    display: table-cell;
    vertical-align: middle;
  }
}

.modal-content {
  max-width: 700px;
  height: 90%;
  margin: 0 auto;
  padding: 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: auto;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-body {
  max-width: 960px;
  margin: 20px auto;

  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #aaaeba;
    margin: 25px 0 40px 0;

    &_mini {
      font-size: 14px;
    }
  }

  &__select {
    margin: 10px 0;
    width: 100%;
  }

  &__btns {
    float: right;
  }
}

.modal-header {
  font-size: 24px;
  margin: 0;
  color: #5574a1;

  &__icon {
    float: right;
    cursor: pointer;
  }
}

.modal-footer {
  padding: 40px 0;

  &__button {
    float: right;
  }
}
</style>
